<template>
  <main>
    <div class="path">
      <i class="el-icon-caret-right"></i>账号中心
      <i class="el-icon-arrow-right"></i>&nbsp;API KEY
    </div>

<!--    <div class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">-->
<!--      <el-button type="primary" style="width: 140px;" icon="el-icon-circle-plus-outline" @click="">创建Api Key</el-button>-->
<!--    </div>-->

    <section class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-table
        :data="tableData.data"
        v-loading="loading"
        stripe
        style="width: 100%">
        <el-table-column
          prop="apiKey"
          label="API KEY"
          :width="660*navCollapse">
        </el-table-column>

        <el-table-column
          prop=""
          label="状态"
          :width="280*navCollapse">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 99" type="danger" disable-transitions>禁用</el-tag>
            <el-tag v-if="scope.row.status === 1" type="success" disable-transitions>正常</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="创建时间">
        </el-table-column>

      </el-table>
    </section>


  </main>
</template>

<style>
.el-table .success-cell {
  background: #F0F9EB;
  font-weight: bold;
}
</style>

<script>
import {mapState} from 'vuex'
import {
  reqApiKey
} from '@/api'

export default {
  name: 'ApiKey',

  data() {
    return {
      tableData: {},
      loading: true,
    }
  },

  async mounted() {
    await this.getApiKey()
  },

  methods: {
    async getApiKey() {
      const result = await reqApiKey()
      if (result.code === 0) {
        this.tableData = result
        this.loading = false
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },


  },

  computed: {
    ...mapState(['navCollapse', 'wrapperWidth']),
  }

}
</script>

<style scoped>

main {
  /*width: 100%;*/
  display: flex;
  flex-direction: column;
}

.content_wrapper {
  width: 82vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
}

</style>



// WEBPACK FOOTER //
// src/pages/CustomerCenter/ApiKey/ApiKey.vue